import { Config, Media } from "./__generated__/graphql";

export const round = (number: number, decimals?: number) => {
  const numberParsed = typeof number === "string" ? parseFloat(number) : number; // to remove
  if (!number || isNaN(numberParsed)) return number;
  return parseFloat(numberParsed.toFixed(decimals || 2));
};

export const findUrlForMediaArray = (media: Media, format: string) => {
  if (!media || !media.formatArray) return null;
  else if (!format) return media.url;

  const foundFormat = media?.formatArray.find(f => f?.name === format);
  return foundFormat?.url || media.url;
};

export const getConfigProperty = (config: Config, module: string, property: string) => {
  const m = config.modules.find((m: any) => m.id === module);
  if (m && m.data) return m.data[property];
  return null;
};
